import React, {useState} from "react";
import { useTranslation } from "react-i18next";
import DropdownComponent from "../_common/dropdown";
import { formatDate } from "../../i18n/dateLocale";




const ProductCatalougeTable = (props) => {
  const { t } = useTranslation();

  return (
    <div className="table-wrapper px-3 pt-3">
     
      <div className="table-wrapper-scroll-y table-scrollbar">
        <div className="table-own table-responsive">
          <table className="table table-admin">
            <thead className="table-head">
              <tr>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "name" ? "active" : ""
                    } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                 
                >
                  <span>{t("common.serialNo")}</span>{" "}
                 
                </th>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "name" ? "active" : ""
                    } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                  onClick={() => props.arraySorting("name")}
                >
                  <span>{t("admin.products.table.productName")}</span>{" "}
                  {props?.sortObj?.sortType === "aesc" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>
                <th className="text-center">
                  <span>{t("admin.products.table.productSku")}</span>
                </th>
                <th className="text-center">
                  <span>{t("admin.products.table.productImage")}</span>
                </th>
                
                <th className="text-center">
                  <span>{t("common.status")}</span>
                </th>
                <th
                  className={`sort-header text-center cursor ${props?.sortObj?.sortVal === "created" ? "active" : ""
                    }
                ${props?.sortObj?.sorType ? "asec" : "desc"}
                `}
                  onClick={() => props.arraySorting("created")}
                >
                  <span>{t("admin.products.table.createdOn")}</span>
                  {props?.sortObj?.sortType === "asec" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>
                <th
                  className={`sort-header text-center cursor ${props?.sortObj?.sortVal === "lastModified" ? "active" : ""
                    }
                ${props?.sortObj?.sorType ? "asec" : "desc"}
                `}
                  onClick={() => props.arraySorting("lastModified")}
                >
                  <span>{t("admin.products.table.updatedOn")}</span>
                  {props?.sortObj?.sortType === "asec" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>
                <th className="text-center">
                  <span>{t("common.action")}</span>
                </th>
              </tr>
            </thead>
            <tbody className="table-body">
              {props.dataList.map((data, i) => {
                const dropDownActions = [ { text: t("common.edit"), onClick:()=>props?.editData(data) } ];
                if(!data?.isDefault) {
                  dropDownActions?.push({ text: data?.isActive ? t("common.deactivate") : t("common.activate"), onClick:()=>props?.toggleData(data) });
                  dropDownActions?.push({ text: t("common.delete"), onClick:()=>props?.deleteData(data) });
                }

                let address = data?.storeNumber + ", " + data?.street;
                if (data?.address) {
                  address = address + ", " + data?.address;
                }
                address = address + ", " + data?.city;
                return (
                  <tr key={data?.storeId || "N/A"}>
                    <td>{i+1}</td>

                    <td>{data?.name || "N/A"}</td>
                    <td>{data?.sku || "N/A"}</td>
                    <td><div className="table-product-img text-center">
                        { data?.image ? <img src={data?.image} width={30} alt="img"/> : "N/A" }
                        </div>
                    </td>
                    <td className="text-center">
                      {data?.isActive ? (
                        <span className="table-isactive">{t("common.active")}</span>
                      ) : (
                        <span className="table-isinactive">{t("common.inactive")}</span>
                      )}
                    </td>
                    <td className="text-center">
                      {data.created
                        ? formatDate(new Date(data?.created))
                        : "NA"}
                    </td>
                    <td className="text-center">
                      {data.lastModified
                        ? formatDate(new Date(data?.lastModified))
                        : "NA"}
                    </td>
                    <td className="nowrap text-center">
                    
                    <div>
                        <DropdownComponent 
                        
                        list={dropDownActions}
                        />
   
    </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ProductCatalougeTable;
